export const ALLOWED_EMAIL_DOMAINS = ['indeedflex.com', 'syftapp.com']
